import React from "react";
import { Plus } from "react-bootstrap-icons";

import AddItemButton from 'components/Buttons/AddItemButton';
import Tag from "components/Tags/Tag";
import ThemedSelect from 'components/ThemedSelect';
import ValuesList from "components/Values/ValuesList";

import ColorPicker from "./help/ColorPicker/ColorPicker";

import "./styles.css";

const FormData = ({
    form,
    type = 'notch',
    notchTypes = [],
    errors,
    onSubmit,
    onCancel,
    setActiveSection,
    setForm
}) => {
    const NOTCH_MAX_LENGTH = 60;
    const NOTE_MAX_LENGTH = 1000;

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setForm(prevForm => ({
            ...prevForm,
            [name]: type === "checkbox" ? checked : value,
        }));
    };

    const handleColorChange = (color) => {
        setForm(prevForm => ({
            ...prevForm,
            color: color,
        }));
    };

    const handleValueRemove = (index) => {
        setForm(prev => ({
            ...prev,
            values: prev.values.filter((_, i) => i !== index)
        }));
    };

    const handleValueChange = (e, index) => {
        const { name, value, type, checked } = e.target;
        let val = value;

        switch (type) {
            case "checkbox":
                if (checked) {
                    val = 'checked';
                } else {
                    val = 'not_checked';
                }
                break;
        }

        setForm(prev => ({
            ...prev,
            values: prev.values.map((item, i) => 
                i === index ? { ...item, [name]: val } : item
            )
        }));
    };

    const handleRemoveTag = (uid) => {
        setForm(prev => ({
            ...prev,
            tags: prev.tags.filter(i => i.uid !== uid)
        }));
    };

    return (
        <div className="card container-height">
            <form id="notchForm" className="d-flex flex-column h-100" onSubmit={onSubmit}>

                <div className="card-header form-card-header-paddings no-background no-border">
                    <div className="p-2">
                        <h3>{`${form.uid ? 'Edit' : 'New'} ${type === 'notch' ? 'Notch' : 'Favorite'}`}</h3>
                        {/* <span className="text-muted">Editing favorite not apply changes </span> */}
                    </div>
                </div>

                <div className="card-body form-card-body-paddings overflow-auto h-100">
                    <div >
                        <div className="mb-2">
                            <div className="d-flex justify-content-between">
                                <label htmlFor="notchName" className="form-label">Notch</label>
                                <small className="text-muted">
                                    {form.notch.length}/{NOTCH_MAX_LENGTH}
                                </small>
                            </div>
                            <input
                                type="text"
                                id="notchName"
                                name="notch"
                                value={form.notch}
                                onChange={handleInputChange}
                                className="form-control"
                                maxLength={NOTCH_MAX_LENGTH}
                                required
                            />
                        </div>
                        {notchTypes.length > 0 && (
                            <div className="mb-2">
                                <label htmlFor="type" className="form-label">Type</label>
                                <ThemedSelect
                                    name="type"
                                    options={notchTypes}
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                    value={notchTypes.find(option => option.value === form.type) || null}
                                    onChange={(selectedOption) => {
                                        setForm(prevForm => ({
                                            ...prevForm,
                                            type: selectedOption.value || "notch"
                                        }));
                                    }}
                                    placeholder="Select type..."
                                />
                            </div>
                        )}

                        <div className="mb-3">
                            <div className="d-flex justify-content-between">
                                <label htmlFor="notchNote" className="form-label">Note</label>
                                <small className="text-muted">
                                    {form.note.length}/{NOTE_MAX_LENGTH}
                                </small>
                            </div>
                            <textarea
                                id="notchNote"
                                name="note"
                                value={form.note}
                                onChange={handleInputChange}
                                className="form-control"
                                rows="3"
                                maxLength={NOTE_MAX_LENGTH}
                            />
                        </div>



                        <div 
                            className="mb-3"
                            style={{
                                marginLeft: '3px'
                            }}
                        >
                            <ColorPicker
                                selectedColor={form.color}
                                onColorChange={handleColorChange}
                            />
                        </div>

                        {/* <div className="form-check mb-3">
                                    <input
                                        type="checkbox"
                                        id="notchPrivate"
                                        name="private"
                                        checked={form.private}
                                        onChange={handleInputChange}
                                        className="form-check-input"
                                    />
                                    <label htmlFor="notchPrivate" className="form-check-label">Private</label>
                                </div> */}

                        {type == 'favorites' && (
                            <div className="form-check mb-2">
                                <label htmlFor="quickAccess" className="form-check-label">Add to quick access</label>
                                <input
                                    type="checkbox"
                                    id="quickAccess"
                                    name="quick_access"
                                    className={`form-check-input ${errors.quick_access ? 'is-invalid' : ''}`}
                                    style={{ width: '20px', height: '20px' }}
                                    checked={form.quick_access}
                                    onChange={handleInputChange}
                                />

                                {errors.quick_access && (
                                    <div className="invalid-feedback">
                                        {errors.quick_access[0]}
                                    </div>
                                )}
                            </div>
                        )}

                        {/* tags */}
                        <div className="mb-2">
                            <h5>Tags</h5>

                            {form.tags && (
                                <div className="mt-2 d-flex flex-wrap gap-2 mb-2">
                                    {form.tags.map((item, index) => (
                                        <Tag 
                                            key={index}
                                            name={item.name} 
                                            onRemove={() => handleRemoveTag(item.uid)} 
                                        />
                                    ))}
                                </div>
                            )}

                            <AddItemButton onClick={() => setActiveSection('tags')} />
                        </div>
          
                        {/* values */}
                        <div className="mb-2">
                            <h5>Values</h5>

                            <ValuesList 
                                items={form.values}
                                onChange={handleValueChange}
                                onDelete={handleValueRemove}
                            />

                            <AddItemButton onClick={() => setActiveSection('values')} />
                        </div>

                    </div>
                </div>


                <div className="card-footer form-card-footer-paddings border-top no-background">
                    <div className="d-flex justify-content-between">
                        <button
                            type="submit"
                            className="btn btn-success"
                            onClick={(e) => {
                                e.preventDefault();
                                onSubmit(e);
                            }}
                        >
                            {form.uid ? 'Save' : 'Add'}
                        </button>
                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={(e) => {
                                e.preventDefault();
                                onCancel();
                            }}
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default FormData;